module.exports = __webpack_public_path__ + "static/img/viral_10.cae9d97c.jpg";